import { css } from 'lit';

import { stacked } from '../media.js';

export const overviewPageStyles = css`
  .tiles {
    display: grid;
    gap: var(--card-gap);
    grid-template-columns: repeat(auto-fit, minmax(min(var(--tile-min-width), calc(50% - var(--card-gap))), 1fr));
    margin-bottom: calc(var(--column-gap) * 1.5);
    counter-reset: tile;
  }

  /* A figure on a sign: large, in the heavy display face, its legend beneath, its tone the bar
     on top. */
  .tile {
    --tile-tone: var(--text);
    position: relative;
    display: block;
    padding: var(--space-4) var(--space-5) var(--space-4);
    border: var(--border-width) solid var(--border);
    border-top: var(--edge-width) solid var(--tile-tone);
    border-radius: var(--radius);
    background: var(--surface-raised);
    color: inherit;
    text-decoration: none;
    counter-increment: tile;
    transition: border-color var(--duration-fast);
  }

  .tile::before {
    content: counter(tile, decimal-leading-zero);
    position: absolute;
    top: var(--space-3);
    right: var(--space-4);
    font-family: var(--font-mono);
    font-size: var(--font-size-2xs);
    letter-spacing: var(--tracking-wider);
    color: var(--text-muted);
  }

  a.tile:hover {
    border-color: var(--text);
    border-top-color: var(--tile-tone);
  }

  .tile .value {
    display: block;
    font-family: var(--font-display);
    font-size: var(--font-size-4xl);
    font-weight: var(--font-display-weight);
    line-height: var(--line-height-tight);
    letter-spacing: var(--font-display-tracking);
    font-variant-numeric: tabular-nums lining-nums;
    color: var(--tile-tone);
  }

  .tile .label {
    color: var(--text-muted);
    font-size: var(--font-size-ui);
    font-weight: var(--font-weight-medium);
  }

  .tile[data-tone='danger'] {
    --tile-tone: var(--tone-danger);
  }

  .tile[data-tone='warning'] {
    --tile-tone: var(--tone-warning);
  }

  .tile[data-tone='ok'] {
    --tile-tone: var(--tone-ok);
  }

  .tile[data-tone='progress'] {
    --tile-tone: var(--tone-progress);
  }

  .columns {
    display: grid;
    gap: var(--column-gap);
    grid-template-columns: var(--columns-main-aside);
    align-items: start;
  }

  @media ${stacked} {
    .columns {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .all-good {
    padding: var(--space-4);
    border: var(--border-width) solid var(--tone-ok);
    border-radius: var(--radius);
    background: var(--tone-ok-soft);
  }

  td.why {
    white-space: normal;
    color: var(--text-muted);
    font-size: var(--font-size-md);
    min-width: 14rem;
  }
`;
